import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PodcastTitle = styled.h3`
  margin-top: 1rem;
  font-weight: bold;
  word-wrap: break-word;
`;

export const CardContainer = styled(Link)`
  /* max-width: 200px; */
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  color: #222;

  &:hover {
    ${PodcastTitle} {
      color: #f9703e;
    }
  }
`;

export const Publisher = styled.p`
  margin-top: 0.5rem;
  font-size: 1.2rem;
  text-decoration: none;
  color: #626262;
`;
